import getPath from '@neonaut/lib-js/es/object/getPath';
import {createSelector} from 'reselect';

import getFeatureProperty from '@mapsight/ui/src/js/helpers/get-feature-property';

import {detailsFeatureSelector} from '../../mapsight-glue/store/selectors';

import {RATINGS} from './controller';


export const captchaSelector = _ => (_[RATINGS].captcha || {});

export const storageSelector = _ => (_[RATINGS].storage || {});

export const storageAuthorSelector = _ => _[RATINGS]?.storage?.author;
export const storageTokenSelector = _ => _[RATINGS]?.storage?.token;


export const createStorageRatingSelector = (sourceId, poiId) =>
	_ => getPath(_, [RATINGS, 'storage', 'features', sourceId, poiId], {});


export const detailsFeatureRatingSelector = createSelector(
	detailsFeatureSelector,
	(feature) => (getFeatureProperty(feature, 'ratings', {}).ratings)
);
